import { httpClient } from '@/services/http/httpClient'

type Params = {
  name: string
  departmentId: string
  areaId: string
  email?: string
  registration?: string
  password?: string
  isAdmin?: boolean
  isManager?: boolean
}

export async function createUser({
  name,
  areaId,
  departmentId,
  email,
  registration,
  password,
  isAdmin,
  isManager,
}: Params): Promise<void> {
  await httpClient.post(`/users/`, {
    name,
    areaId,
    departamentId: departmentId,
    isAdmin,
    isManager,
    ...(email && { email }),
    ...(registration && { registration }),
    ...(password && { password }),
  })
}
